import { useCurrentModule } from '../components';
import { useSwitchFlows } from './useSwitchFlows';
export const AI_RECOMMENDATION_SPEC = 'specs.premium.EclipseDesktopSocialProof';
export const AI_REC_PREMIUM_PLAN_SPEC = 'aiRecPremiumPlan';
export const useAiRecommendationEnabled = () => {
  const module = useCurrentModule();
  const {
    ready,
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    isSwitchFlow,
    isLoading: isSwitchFlowLoading
  } = useSwitchFlows();
  const isMobile = module.moduleName === 'eclipse-package-picker-mobile-module';
  const isLoading = !isMobile && (ready === false || isSwitchFlowLoading);
  const isEligible = !isMobile && ready !== false && !isSwitchFlowLoading && isSwitchFlow === false;
  const isPremiumPlanVariant = isEligible && experiments.isEnabled(AI_REC_PREMIUM_PLAN_SPEC);
  const isEnabled = isEligible && (experiments.isEnabled(AI_RECOMMENDATION_SPEC) || isPremiumPlanVariant);
  return {
    isEnabled,
    isLoading,
    isPremiumPlanVariant
  };
};
//# sourceMappingURL=useAiRecommendationEnabled.js.map